<div class="content-section">
  <app-trial-license-warning></app-trial-license-warning>
  <lib-campaigns></lib-campaigns>
  <div class="title-div">
    <div class="row">
      <div class="col p-0 d-flex justify-content-between align-items-center changeInstitution">
          <div class="col-11 p-0">
            <h2 class="background_title">{{ "E_LEARNING.SPELLING_2" | translate }}</h2>
          </div>
      </div>  
    </div>
  </div>  
  <div class="container-fluid alone ">
    <div class="container-cards">

      <div class="card_bd" (click)="Managetutorials()">
        <div class="col-12 p-0 card_media_bd">
          <div class="card_media_bd_top">
            <img
              src="assets/ph-bhp-elearning/svg/icon-tutorial.svg"
              alt="Imagen tutorial"
              class="mx-auto d-block"
            />
          </div>
          <div class="card_content_bd d-flex align-items-center">
            <div class="col-12 card-title">
              {{ "E_LEARNING.TUTORIALS" | translate }}
            </div>
          </div>
        </div>
      </div>

      <div class="card_bd" (click)="Managepuzzles()" *ngIf="isSOP">
        <div class="col-12 p-0 card_media_bd">
          <div class="card_media_bd_top">
            <img
              src="assets/ph-bhp-elearning/svg/icon-puzzle.svg"
              alt="Imagen tutorial"
              class="mx-auto d-block"
            />
          </div>
          <div class="card_content_bd d-flex align-items-center">
            <div class="col-12 card-title">
              {{ "E_LEARNING.PUZZLES" | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

